module.exports = __webpack_public_path__ + "img/Body_feathers_DiffuseColor.a0ee68f.png";